import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import { EmbedingListWrapper } from './training-list/EmbeddingsList'




const TrainingPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        
      </Route>
      <Route index element={  <EmbedingListWrapper></EmbedingListWrapper>} />
    </Routes>
  )
}

export default TrainingPage
